import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

function LogHabitsCard({ habitLogs }) {
  const { t } = useTranslation("athlete-portal");
  if (!habitLogs?.accountabilities?.length) return null;
  return (
    <div className="log-card log-card--habits">
      <div className="log-card__header">
        <SvgIcon src="/img/new-icons/list-circle.svg" useCurrentColor={true} />
        {t("calendar.cards.habits.title")}
      </div>
      {habitLogs.accountabilities.map((habit) => (
        <div
          key={habit._id}
          className={`log-card__habit-row${habit.done ? " done" : ""}`}
        >
          <input type="checkbox" checked={!!habit.done} readOnly />
          <span>{habit.title}</span>
        </div>
      ))}
    </div>
  );
}

export default LogHabitsCard;
